<template>
    <Button
        v-bind="$props"
        class="buttonLink"
        variant="text"
        :automaticPosition="false"
        :font="font">
        <slot />
    </Button>
</template>

<script lang="ts">
    import { defineComponent, computed, PropType } from 'vue';
    import { Color } from '@ui/components/Button/Button.interfaces';
    import Button, { buttonProps } from './Button.vue';

    export default defineComponent({
        name: 'ButtonLink',
        components: { Button },
        props: {
            ...buttonProps,
            bold: { type: Boolean },
            color: { type: String as PropType<Color>, default: 'black' },
        },
        setup(props) {
            const font = computed(() => {
                const { size, bold } = props;
                switch (size) {
                    case 'xl':
                        return bold ? 'font-link-xl-bold' : 'font-link-xl';
                    case 'l':
                        return bold ? 'font-link-l-bold' : 'font-link-l';
                    case 'm':
                        return bold ? 'font-link-m-bold' : 'font-link-m';
                    default:
                        return bold ? 'font-link-s-bold' : 'font-link-s';
                }
            });

            return { font };
        },
    });
</script>
<style lang="scss" scoped>
    @forward './ButtonLink.scss';
</style>
